import { render, staticRenderFns } from "./eval-detail-s2-2.vue?vue&type=template&id=4f150e90"
import script from "./eval-detail-s2-2.vue?vue&type=script&lang=js"
export * from "./eval-detail-s2-2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports